import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  radio: {
    padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
  },
  input: {
    "&::placeholder": {
      color: "#88909F",
      opacity: 1,
    },
  },
  inputLabel: {
    color: "#0E1F3C",
    whiteSpace: "normal",
  },
}));
